module.exports = __webpack_public_path__ + "img/menu-triangulos.95df5ef6.svg";